import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import TablePagination from "@mui/material/TablePagination";
import { useDispatch, useSelector } from "react-redux";
import TablePaginationActions from "../../../shared/components/Table/Actions";
import { page } from "../Sala/api-sala";
import { setSalas } from "./actions/actions";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import Loading from "../../UI/Loading";
import MensagemAll from "./MensagemAll";
import { EmptyMensagens } from "./MensagemListUser";

export default function MensagemListAll() {
  const salas = useSelector((state) => state.salas);
  const dispatch = useDispatch();
  // A página fica no Redux para voltar ao mesmo ponto ao sair de uma sala.
  const [pageNumber, setPageNumber] = useState(salas?.number ?? 0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    page(pageNumber)
      .then((data) => {
        if (!active || !data) return;
        if (data.error) {
          errorMessage(data.message);
        } else {
          dispatch(setSalas(data));
        }
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, [dispatch, pageNumber]);

  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description="Carregando Mensagens..." />
      </Box>
    );
  }

  const content = salas?.content ?? [];

  if (content.length === 0) {
    return <EmptyMensagens>Nenhuma conversa encontrada.</EmptyMensagens>;
  }

  return (
    <Box>
      <List disablePadding sx={{ border: 1, borderColor: "divider", borderRadius: 2, overflow: "hidden" }}>
        {content.map((sala) => (
          <MensagemAll key={sala.codigo} sala={sala} />
        ))}
      </List>
      <TablePagination
        rowsPerPageOptions={[]}
        rowsPerPage={salas.size || 0}
        component="div"
        count={salas.totalElements || 0}
        page={salas.number || 0}
        onPageChange={(event, newPage) => setPageNumber(newPage)}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? `${count} registros` : `mais de ${to}`}`
        }
        ActionsComponent={TablePaginationActions}
      />
    </Box>
  );
}
